// Detector global de escaneos de QR (lectores USB/Bluetooth tipo HID Keyboard).
// Funciona en cualquier tab de la app y postea el resultado a un BroadcastChannel
// que el kiosk del checkpoint escucha — así el escaneo llega al kiosk aunque el
// focus esté en otro tab/ventana en el mismo browser.

export const QR_SCAN_CHANNEL = "dashcore-qr-scan";

interface QrScanMessage {
  token: string;
  source: "keystroke";
}

const FAST_KEYSTROKE_THRESHOLD_MS = 100;
const MIN_QR_LENGTH = 100;

let initialized = false;

const codeToBase64UrlChar = (e: KeyboardEvent): string | null => {
  const code = e.code;
  if (!code) return null;

  if (code.length === 4 && code.startsWith("Key")) {
    const letter = code.charAt(3);
    return e.shiftKey ? letter : letter.toLowerCase();
  }

  if (code.length === 6 && code.startsWith("Digit") && !e.shiftKey) {
    return code.charAt(5);
  }

  if (code === "Minus") return e.shiftKey ? "_" : "-";
  if (code === "Period" && !e.shiftKey) return ".";

  return null;
};

export function initQrScanBroadcaster(): void {
  if (initialized || typeof window === "undefined") return;
  initialized = true;

  const channel = new BroadcastChannel(QR_SCAN_CHANNEL);
  let buffer = "";
  let lastKeyTime = 0;

  document.addEventListener("keydown", (e: KeyboardEvent) => {
    const now = Date.now();
    const delta = now - lastKeyTime;
    lastKeyTime = now;

    if (e.key === "Enter") {
      if (
        buffer.length >= MIN_QR_LENGTH &&
        /^[A-Za-z0-9_.-]+$/.test(buffer)
      ) {
        e.preventDefault();
        const message: QrScanMessage = { token: buffer, source: "keystroke" };
        channel.postMessage(message);
      }
      buffer = "";
      return;
    }

    if (delta > FAST_KEYSTROKE_THRESHOLD_MS) {
      buffer = "";
    }

    const char = codeToBase64UrlChar(e);
    if (char) buffer += char;
  });
}
